/**
 * @generated SignedSource<<dc3744566066aa20709be54b4714d387>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorePackageModal_package$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StorePackageDetailFooter_package" | "StorePackageDetail_package" | "StorePackageSuccess_package" | "usePackageDisplayName_package">;
  readonly " $fragmentType": "StorePackageModal_package";
};
export type StorePackageModal_package$key = {
  readonly " $data"?: StorePackageModal_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorePackageModal_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorePackageModal_package",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorePackageDetail_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePackageDisplayName_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorePackageDetailFooter_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorePackageSuccess_package"
    }
  ],
  "type": "Package",
  "abstractKey": "__isPackage"
};

(node as any).hash = "3c7e9b8af642ba54892837bff2ff7da2";

export default node;
